/**
 * get all countries in one cat for pie
 * @param  {array} arr     the output from cntsInOneCatForLine function
 * @return {array}         array in above format 
 */
/*
[{
  name: "Country",
  //colorByPoint: true,
  data: [{
    name: "Canada",
    y: [56.33, 65, 25, ...]
  }, {
    name: "Mexico",
    y: [24.03, 23, 3...]
  }, 
  ...
  ]
}]
 */
'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
exports.cntsInOneCatForPie = cntsInOneCatForPie;

function cntsInOneCatForPie(arr) {

  var output = [];

  output.push({
    name: "Country",
    //colorByPoint: true,
    data: []
  });

  arr.forEach(function (obj) {
    output[0].data.push({
      name: obj['name'],
      y: obj['data']
    });
  });

  return output;
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9Vc2Vycy9rYXJlbi9Eb2N1bWVudHMvbXlfcHJvamVjdC9mb29kL3NyYy9qcy9kYXRhTW9kZWwvY250c0luT25lQ2F0Rm9yUGllLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQW9CTyxTQUFTLGtCQUFrQixDQUFDLEdBQUcsRUFBQzs7QUFFckMsTUFBSSxNQUFNLEdBQUcsRUFBRSxDQUFBOztBQUVmLFFBQU0sQ0FBQyxJQUFJLENBQUM7QUFDVixRQUFJLEVBQUUsU0FBUzs7QUFFZixRQUFJLEVBQUUsRUFBRTtHQUNULENBQUMsQ0FBQTs7QUFFRixLQUFHLENBQUMsT0FBTyxDQUFDLFVBQUMsR0FBRyxFQUFHO0FBQ2pCLFVBQU0sQ0FBQyxDQUFDLENBQUMsQ0FBQyxJQUFJLENBQUMsSUFBSSxDQUFDO0FBQ2xCLFVBQUksRUFBRSxHQUFHLENBQUMsTUFBTSxDQUFDO0FBQ2pCLE9BQUMsRUFBRSxHQUFHLENBQUMsTUFBTSxDQUFDO0tBQ2YsQ0FBQyxDQUFBO0dBQ0gsQ0FBQyxDQUFBOztBQUVGLFNBQU8sTUFBTSxDQUFBO0NBQ2QiLCJmaWxlIjoiL1VzZXJzL2thcmVuL0RvY3VtZW50cy9teV9wcm9qZWN0L2Zvb2Qvc3JjL2pzL2RhdGFNb2RlbC9jbnRzSW5PbmVDYXRGb3JQaWUuanMiLCJzb3VyY2VzQ29udGVudCI6WyIvKipcbiAqIGdldCBhbGwgY291bnRyaWVzIGluIG9uZSBjYXQgZm9yIHBpZVxuICogQHBhcmFtICB7YXJyYXl9IGFyciAgICAgdGhlIG91dHB1dCBmcm9tIGNudHNJbk9uZUNhdEZvckxpbmUgZnVuY3Rpb25cbiAqIEByZXR1cm4ge2FycmF5fSAgICAgICAgIGFycmF5IGluIGFib3ZlIGZvcm1hdCBcbiAqL1xuLypcblt7XG4gIG5hbWU6IFwiQ291bnRyeVwiLFxuICAvL2NvbG9yQnlQb2ludDogdHJ1ZSxcbiAgZGF0YTogW3tcbiAgICBuYW1lOiBcIkNhbmFkYVwiLFxuICAgIHk6IFs1Ni4zMywgNjUsIDI1LCAuLi5dXG4gIH0sIHtcbiAgICBuYW1lOiBcIk1leGljb1wiLFxuICAgIHk6IFsyNC4wMywgMjMsIDMuLi5dXG4gIH0sIFxuICAuLi5cbiAgXVxufV1cbiAqL1xuZXhwb3J0IGZ1bmN0aW9uIGNudHNJbk9uZUNhdEZvclBpZShhcnIpe1xuICBcbiAgbGV0IG91dHB1dCA9IFtdXG4gIFxuICBvdXRwdXQucHVzaCh7XG4gICAgbmFtZTogXCJDb3VudHJ5XCIsXG4gICAgLy9jb2xvckJ5UG9pbnQ6IHRydWUsXG4gICAgZGF0YTogW11cbiAgfSlcblxuICBhcnIuZm9yRWFjaCgob2JqKT0+e1xuICAgIG91dHB1dFswXS5kYXRhLnB1c2goe1xuICAgICAgbmFtZTogb2JqWyduYW1lJ10sXG4gICAgICB5OiBvYmpbJ2RhdGEnXVxuICAgIH0pXG4gIH0pXG5cbiAgcmV0dXJuIG91dHB1dFxufSJdfQ==